import { render, staticRenderFns } from "./department2.vue?vue&type=template&id=5258b07a&scoped=true"
import script from "./department2.vue?vue&type=script&lang=js"
export * from "./department2.vue?vue&type=script&lang=js"
import style0 from "./department2.vue?vue&type=style&index=0&id=5258b07a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5258b07a",
  null
  
)

export default component.exports